import { Form, Input, Select, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';

import { CSVLink } from "react-csv";
import { deleteLeavePolicy, getAllLeaveAllocation, leaveAllocationAllUsers, updateLeavePolicy } from '../../redux/rtk/features/leavePolicy/leavePolicySlice';
import getCompanyIdFromToken from '../../utils/getCompanyIdFromToken';
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import EditLeavePolicyModal from './editLeavePolicy';


const AllocatedLeave = () => {

    const { allocatedLeave = [], loading } = useSelector((state) => state.leavePolicy);

    const [loader, setLoader] = useState(false);
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [leaveTypes, setLeaveTypes] = useState([]);
    const [selectedPolicy, setSelectedPolicy] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const companyId = getCompanyIdFromToken();
    const [selectedPolicies, setSelectedPolicies] = useState([]);
    useEffect(() => {
        dispatch(getAllLeaveAllocation());
    }, [dispatch]);

    // const leavePolicyOptions = Array.from(new Set(allocatedLeave.map(item => item.leavePolicy?.name))).map(name => ({
    //     label: name,
    //     value: name,
    // }));
    const leavePolicyOptions = Array.from(new Set(allocatedLeave.map(item => item.leavePolicy?.name)))
        .filter(Boolean) // Remove any falsy values
        .sort((a, b) => a.localeCompare(b)) // Alphabetical sort
        .map(name => ({
            label: name,
            value: name,
        }));
    const handleDelete = (id) => {
        dispatch(deleteLeavePolicy(id))
            .then(() => {
                dispatch(getAllLeaveAllocation());
            })
            .catch((error) => {
                toast.error('Error in deleting leave policy');
            });
    };

    const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

    const handleEditClick = (record) => {
        setSelectedPolicy(record);
        setEditModalVisible(true);
    };

    const handleEditModalCancel = () => {
        setEditModalVisible(false);
        setSelectedPolicy(null);
    };

    const handleEditModalOk = (values) => {
        dispatch(updateLeavePolicy({ id: selectedPolicy.id, values }))
            .then(() => {
                setEditModalVisible(false);
                setSelectedPolicy(null);
                dispatch(getAllLeaveAllocation());
            })
            .catch((error) => {
                toast.error("Error updating policy");
            });
    };

    const handleLeaveAllocationClick = () => {
        setLoader(true);
        dispatch(leaveAllocationAllUsers({ company_id: companyId }))
            .then(() => {
                setLoader(false);
                dispatch(getAllLeaveAllocation());
            })
            .catch((error) => {
                setLoader(false);
                toast.error('Error in adding Leave Allocations. Try again.');
                console.log(error.message);
            });
    };

    const filteredList = allocatedLeave.filter(item => {
        const leavePolicyName = item.leavePolicy?.name || '';
        const firstName = item.user?.firstName || '';
        const lastName = item.user?.lastName || '';
        const employeeId = item.user?.employeeId || '';

        // Combined search logic for both employee name and employee code
        const searchLower = searchTerm.toLowerCase();
        return (
            (selectedPolicies.length === 0 || selectedPolicies.includes(leavePolicyName)) &&
            (`${firstName} ${lastName}`.toLowerCase().includes(searchLower) || employeeId.toLowerCase().includes(searchLower))
        );
    });


    const sortedList = filteredList.sort((a, b) => {
        const nameA = `${a.user?.firstName || ''} ${a.user?.lastName || ''}`.toLowerCase();
        const nameB = `${b.user?.firstName || ''} ${b.user?.lastName || ''}`.toLowerCase();

        if (nameA < nameB) {
            return -1; // a comes before b
        }
        if (nameA > nameB) {
            return 1; // b comes before a
        }
        return 0; // names are equal
    });

    const csvData = sortedList.map((item, index) => ({
        serial: index + 1,
        employeeName: `${item.user?.firstName || ''} ${item.user?.lastName || ''}`,
        employeeCode: item.user?.employeeId || 'N/A',
        leavePolicy: item.leavePolicy?.name || 'N/A',
        annualLeave: item.annualLeave || 'N/A',
        pendingLeaves: item.pendingLeaves || 'N/A',
    }));

    // Updated headers with serial number
    const headers = [
        { label: "S.No", key: "serial" },
        { label: "Employee Name", key: "employeeName" },
        { label: "Employee Code", key: "employeeCode" },
        { label: "Leave Policy", key: "leavePolicy" },
        { label: "Annual Leave", key: "annualLeave" },
        { label: "Pending Leaves", key: "pendingLeaves" },
    ];

    const columns = [
        {
            title: 'S.No',
            dataIndex: 'serial',
            key: 'serial',
        },
        {
            title: 'Employee Name',
            key: 'employeeName',
            // render: (_, record) => `${record.user.firstName} ${record.user.lastName}`,
            render: (_, record) => `${record.user?.firstName || ''} ${record.user?.lastName || ''}`.trim() || 'N/A',
        },
        {
            title: 'Employee Code',
            key: 'employeeCode',
            //   render: (_, record) => `${record.user.employeeId}`,
            render: (_, record) => record.user.employeeId || 'N/A',

        },
        {
            title: 'Leave',
            key: 'leavePolicy',
            render: (_, record) => record.leavePolicy?.name || 'N/A',
        },
        {
            title: 'Annual Leave',
            dataIndex: 'annualLeave',
            key: 'annualLeave',
        },
        // {
        //     title: 'Monthly Leave',
        //     dataIndex: 'monthlyLeave',
        //     key: 'monthlyLeave',
        // },
        {
            title: 'Pending Leaves',
            dataIndex: 'pendingLeaves',
            key: 'pendingLeaves',
        },
    ];

    const handleLeavePolicyChange = (value) => {
        setSelectedPolicies(value);
    };
    return (
        <>


            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                {/* <Popconfirm
                    title="Are you sure you want to allocate leaves to all users?"
                    onConfirm={handleLeaveAllocationClick}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button
                        type="primary"
                        loading={loader}
                    >
                        Allocate Leave to All Users
                    </Button>
                </Popconfirm> */}
                <CsvLinkBtn>
                    <CSVLink
                        data={csvData}
                        headers={headers}
                        filename={`userLeaveDetails`}
                        className="btn btn-primary"
                        target="_blank"
                    >
                        Download CSV
                    </CSVLink>
                </CsvLinkBtn>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Select
                        mode="multiple"
                        // style={{ width: '200px' }}
                        placeholder="Select Leave Policies"
                        options={leavePolicyOptions}
                        value={selectedPolicies}
                        onChange={handleLeavePolicyChange}
                    />
                    <Input
                        placeholder="Search by Name or Employee Code"
                        style={{ width: '400px' }}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            <Table columns={columns} dataSource={sortedList ? addKeys(sortedList) : []} />

            <EditLeavePolicyModal
                visible={editModalVisible}
                onCancel={handleEditModalCancel}
                onOk={handleEditModalOk}
                initialValues={selectedPolicy}
                leaveTypes={leaveTypes}
                loading={loading}
            />
        </>
    );
};

export default AllocatedLeave;
